import * as React from 'react';
import {useEffect, useState} from "react";
import type { MenuData } from "../../js/data/menuData.ts";
import { fetchMenuByUrl } from "../../js/loaders.ts";
import Header from "./header.tsx";

type Props = {}

function HeaderLoader({...otherProps}: Props) {

	const [menu, setMenu] = useState<MenuData>(null);

	useEffect(() => {
		fetchMenuByUrl('main').then((data) => {
			setMenu(data);
		});
	}, []);

	return (<>
		<Header menu={menu} pathname={window.location.pathname} {...otherProps}/>
	</>);
}

export default HeaderLoader;
